import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import InputRow from '../../../Components/InputRow';
import AppColor from '../../../AppColor';

/** Bulma `.input` / `.control` height — keeps ×, =, and delete aligned with inputs */
const INPUT_CONTROL_HEIGHT = '2.25em';

/** Stretches with row height; use inside a Bulma `.column`, not on the column itself */
const fieldCellWrap = {
	flex: '1 1 0',
	minWidth: 0,
	minHeight: 0,
	display: 'flex',
	flexDirection: 'column',
};

const columnFlex = {
	display: 'flex',
	flexDirection: 'column',
	minWidth: 0,
	alignSelf: 'stretch',
};

/**
 * Spacer fills label area; glyph is vertically centered in the same band as `.input`.
 * Use with `InputRow pinInputToBottom` so all inputs share one baseline.
 */
function FormulaOperator({ children }) {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignSelf: 'stretch',
				width: 28,
				minWidth: 28,
				flexShrink: 0,
			}}
			aria-hidden="true"
		>
			<div style={{ flex: '1 1 auto', minHeight: 0 }} />
			<div
				style={{
					height: INPUT_CONTROL_HEIGHT,
					minHeight: INPUT_CONTROL_HEIGHT,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontSize: '1.05rem',
					fontWeight: 600,
					lineHeight: 1,
					color: '#7a7a7a',
					userSelect: 'none',
				}}
			>
				{children}
			</div>
		</div>
	);
}

const inlineFieldsStyle = {
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'stretch',
	flexWrap: 'nowrap',
	gap: 8,
	width: '100%',
	minWidth: 0,
};

const inlineFieldsFill = {
	...inlineFieldsStyle,
	flex: '1 1 auto',
	minHeight: 0,
};

export default class FITItemVisa extends React.Component {
	toNumber = value => {
		const num = Number(value);
		return Number.isFinite(num) ? num : 0;
	};

	componentDidMount() {
		this.syncVisaComputedTotals();
	}

	componentDidUpdate(prevProps) {
		this.syncVisaComputedTotals();
	}

	syncVisaComputedTotals = () => {
		const { fitDetails, onChange, fitType } = this.props;
		if (fitType !== 'fitVisa' || !Array.isArray(fitDetails)) return;

		const amount = this.toNumber(this.props.amount);
		fitDetails.forEach((detail, index) => {
			const computedPrice = amount * this.toNumber(detail.pricePerPiece);
			const computedSalePrice = amount * this.toNumber(detail.salePricePerPiece);
			if (this.toNumber(detail.price) !== computedPrice) {
				onChange(index, 'price', computedPrice);
			}
			if (this.toNumber(detail.salePrice) !== computedSalePrice) {
				onChange(index, 'salePrice', computedSalePrice);
			}
		});
	};

	removeRow = index => {
		this.props.onRemove(index);
	};

	renderDeleteColumn = index => (
		<div
			className="column is-1"
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignSelf: 'stretch',
				flexShrink: 0,
				maxWidth: 52,
				textAlign: 'center',
				minHeight: 0,
			}}
		>
			<div style={{ flex: '1 1 auto', minHeight: 0 }} />
			<div
				style={{
					height: INPUT_CONTROL_HEIGHT,
					minHeight: INPUT_CONTROL_HEIGHT,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<button
					type="button"
					className="button is-small is-text"
					style={{ padding: 2, minWidth: 'auto', color: '#f14668', height: 'auto' }}
					onClick={() => this.removeRow(index)}
					aria-label="ลบรายการ"
				>
					<FontAwesomeIcon icon="minus-circle" style={{ fontSize: '1.35rem' }} />
				</button>
			</div>
		</div>
	);

	renderVisaFormulaRow = (detail, index) => {
		const amount = this.toNumber(this.props.amount);
		const totalPrice = amount * this.toNumber(detail.pricePerPiece);
		const totalSalePrice = amount * this.toNumber(detail.salePricePerPiece);
		return (
			<div className="columns is-multiline" key={'fitDetail' + index} style={{ marginLeft: 0, marginRight: 0, alignItems: 'stretch' }}>
				<div className="column is-3" style={columnFlex}>
					<InputRow
						title="รายการ"
						labelSize="s"
						placeholder="รายการ"
						keyProps="title"
						value={detail.title}
						onInputChange={(key, value) => this.props.onChange(index, key, value)}
						disabled={false}
						pinInputToBottom
					/>
				</div>
				<div className="column is-2" style={columnFlex}>
					{detail.title !== 'ค่าบริการยื่น VISA' ? (
						<div style={fieldCellWrap}>
							<InputRow
								title="ค่าบริการต่อเล่ม"
								labelSize="s"
								placeholder="ค่าบริการต่อเล่ม"
								keyProps="pricePerPiece"
								type="number"
								min={0}
								value={detail.pricePerPiece}
								onInputChange={(key, value) => this.props.onChange(index, key, value)}
								disabled={false}
								hideLabel={false}
								pinInputToBottom
							/>
						</div>
					) : (
						<></>
					)}
				</div>
				<div className="column is-2" style={columnFlex}>
					<div style={fieldCellWrap}>
						<InputRow
							title="ราคาขายต่อเล่ม"
							labelSize="s"
							placeholder="ราคาขายต่อเล่ม"
							keyProps="salePricePerPiece"
							type="number"
							min={0}
							value={detail.salePricePerPiece}
							onInputChange={(key, value) => this.props.onChange(index, key, value)}
							disabled={false}
							hideLabel={false}
							pinInputToBottom
						/>
					</div>
				</div>
				<div className="column is-2" style={columnFlex}>
					{detail.title !== 'ค่าบริการยื่น VISA' ? (
						<div style={fieldCellWrap}>
							<InputRow
								title="ต้นทุนรวม"
								labelSize="s"
								placeholder="ต้นทุนรวม"
								keyProps="price"
								type="number"
								value={totalPrice}
								// value={detail.price}
								onInputChange={(key, value) => this.props.onChange(index, key, Number(value))}
								disabled={true}
								hideLabel={false}
								pinInputToBottom
							/>
						</div>
					) : (
						<></>
					)}
				</div>
				<div className="column is-2" style={columnFlex}>
					<div style={fieldCellWrap}>
						<InputRow
							title="ราคาขายรวม"
							labelSize="s"
							placeholder="ราคาขายรวม"
							keyProps="salePrice"
							type="number"
							value={totalSalePrice}
							onInputChange={(key, value) => this.props.onChange(index, key, Number(value))}
							disabled={true}
							hideLabel={false}
							pinInputToBottom
						/>
					</div>
				</div>
				{this.renderDeleteColumn(index)}
			</div>
		);
	};

	/** Hotel, car rental, insurance, etc. — title + sale + cost only */
	renderSimpleDetailRow = (detail, index) => (
		<div className="row columns" key={'fitDetail' + index}>
			<div className="column is-5">
				<InputRow
					title="รายการ"
					labelSize="s"
					placeholder="รายการ"
					keyProps="title"
					value={detail.title}
					onInputChange={(key, value) => this.props.onChange(index, key, value)}
					disabled={false}
				/>
			</div>
			<div className="column is-3">
				<InputRow
					title="ราคาขาย (THB)"
					labelSize="s"
					placeholder="ราคาขาย (THB)"
					keyProps="salePrice"
					type="number"
					value={detail.salePrice}
					onInputChange={(key, value) => this.props.onChange(index, key, value)}
					disabled={false}
				/>
			</div>
			<div className="column is-3">
				<InputRow
					title="ต้นทุน (THB)"
					labelSize="s"
					placeholder="ต้นทุน (THB)"
					keyProps="price"
					type="number"
					value={detail.price}
					onInputChange={(key, value) => this.props.onChange(index, key, value)}
					disabled={false}
				/>
			</div>
			<div className="column is-1" style={{ paddingTop: 50, textAlign: 'center' }}>
				<button
					type="button"
					className="button is-small is-text"
					style={{ padding: 4, minWidth: 'auto', color: '#f14668' }}
					onClick={() => this.removeRow(index)}
					aria-label="ลบรายการ"
				>
					<h4 className="title is-4" style={{ color: 'inherit', margin: 0 }}>
						<FontAwesomeIcon icon="minus-circle" />
					</h4>
				</button>
			</div>
		</div>
	);

	renderRow = () => {
		const { fitDetails, fitType } = this.props;
		if (!fitDetails) return null;
		const isFitVisa = fitType === 'fitVisa';
		return fitDetails.map((detail, index) => (isFitVisa ? this.renderVisaFormulaRow(detail, index) : this.renderSimpleDetailRow(detail, index)));
	};

	render() {
		return (
			<div className="row">
				{this.renderRow()}
				<div
					className="row box clickable"
					style={{ backgroundColor: AppColor.bulma.isPrimary, textAlign: 'center', padding: 8, color: 'white' }}
					onClick={this.props.onAdd}
				>
					เพิ่มรายการย่อย
				</div>
			</div>
		);
	}
}
